<div class="mb-1 note">
  <p *ngIf="!note.innerHTML" [innerHTML]="note.text"></p>
  <p class="" *ngIf="note.innerHTML">
    {{note.text}}
    &nbsp;<span *ngIf="note.innerHTML" [innerHTML]="note.innerHTML"></span>
  </p>
  <a (click)="clearNote()">&times;</a>
</div>
